export type SitePadRole = 'area' | 'label';

export function buildSitePadFilter(layout: string, role: SitePadRole) {
  return ['all',
    ['==', ['get', 'layout'], layout],
    ['==', ['get', 'role'], role],
  ];
}
